<template>
  <div>
<!--    <background-img v-if="getBackground && !getDarker"></background-img>-->

<!--    <div class="app-sidebar-class" v-if="model" @click="mouseenterNavigation()"></div>-->
<!--    <div class="app-sidebar-class" v-else @mouseenter="mouseenterNavigation()"></div>-->
    <v-overlay :value="getLoading" opacity="1" z-index="99999999" :color="getDarker ? 'black':'white'">
      <v-img :src="loadingImage"
             width="100"></v-img>
      <div class="ma-2">
        loading ......
      </div>
    </v-overlay>
  </div>
</template>

<script>
// import BackgroundImg from "@/components/BackgroundImg";
import {mapGetters} from "vuex";

export default {
  name: "Content",
  props: {
    model: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loadingImage: require('@/assets/loading.gif')
  }),
  components: {
    // 'background-img': BackgroundImg,
  },
  computed: {
    ...mapGetters(['getLoading', 'getDarker', 'getBackground']),
  },
  methods: {
    // mouseenterNavigation() {
    //   this.$emit('move', true);
    //   console.log('移入')
    // },
    // mouseleaveNavigation() {
    //   this.$emit('move', false);
    //   console.log('移出')
    // }
  }
}
</script>

<style scoped>

.app-sidebar-class {
  position: fixed;
  z-index: 3;
  top: 0;
  bottom: 0;
  width: 56px;
}

</style>
